module.exports = [
  "#",
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/,
  /[A-Za-z1-9?!$-><{}]/
]



// WEBPACK FOOTER //
// ./src/components/MaskedHashtagInput/hashtagMaskArr.js